import { cva as t, ct as e } from "@/styled-system/css";
const s = t({
  base: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    gap: e("TextButton.spacing.gap.label-toIcon"),
    focusOutline: !0
  },
  variants: {
    tone: {
      brand: {},
      neutral: {},
      subtle: {}
    },
    disabled: {
      true: {
        opacity: "disabled",
        cursor: "default"
      },
      false: {}
    },
    onImpact: {
      true: {},
      false: {}
    },
    isGrouped: {
      true: {
        textAlign: "center",
        alignSelf: "stretch"
      },
      false: {}
    },
    size: {
      sm: {},
      md: {},
      lg: {}
    },
    textStyle: {
      body: {},
      "body-bold": {},
      "body-sm": {},
      "body-sm-bold": {}
    }
  },
  compoundVariants: [
    {
      isGrouped: !0,
      size: "sm",
      css: {
        paddingInline: e("Button.spacing.sm.padding.horz")
      }
    },
    {
      isGrouped: !0,
      size: "md",
      css: {
        paddingInline: e("Button.spacing.md.padding.horz")
      }
    },
    {
      isGrouped: !0,
      size: "lg",
      css: {
        paddingInline: e("Button.spacing.lg.padding.horz")
      }
    }
  ]
});
export {
  s as textButtonRootRecipe
};
//# sourceMappingURL=text-button-root.styles.js.map
